import {
  ActivityCardTypeEnum,
  type ActivityEntity,
  type FlowEntityActivityType,
} from '@assembly-web/services';
import { BellIcon } from '@heroicons/react/24/outline';
import { defineMessages, useIntl } from 'react-intl';

import type { ToolbarItem } from '../../..';
import { Button } from '../../..';
import { Card } from './Card';

const messages = defineMessages({
  viewFeed: {
    defaultMessage: 'View feed',
    id: 'zPji8t',
  },
  startPost: {
    defaultMessage: 'Start post',
    id: 'pCERTC',
  },
});

type ToolbarMenuClickEventArgs = ToolbarItem & {
  url?: string;
  cardId: string;
  card: ActivityEntity | null;
  cardPosition: number;
  directReport?: boolean;
};

type FlowDueCardProps = {
  titleText: string;
  subText?: string;
  url?: string;
  cardId: string;
  cardPosition: number;
  cardWrapperRef?: React.RefObject<HTMLAnchorElement>;
  onViewFeedClick: (e: React.MouseEvent) => void;
  handleOnStartPostClick: (e: React.MouseEvent) => void;
  onClick?: (cardId: string) => void;
  onToolbarItemClick?: (args: ToolbarMenuClickEventArgs) => void;
  primaryToolbarItems?: ToolbarItem[] | undefined;
  secondaryToolbarItems?: ToolbarItem[] | undefined;
  preview?: React.ReactNode;
} & Omit<FlowEntityActivityType, 'type'>;

export function DirectReportActivityCard({
  titleText,
  subText,
  entity,
  cardId,
  url,
  onClick,
  cardPosition,
  cardWrapperRef,
  onViewFeedClick,
  onToolbarItemClick,
  primaryToolbarItems,
  secondaryToolbarItems,
  handleOnStartPostClick,
  preview,
}: FlowDueCardProps) {
  const { formatMessage } = useIntl();

  return (
    <Card
      icon={<BellIcon className="h-4 w-4 stroke-2 max-md:max-w-none" />}
      text={titleText}
      subText={subText}
      onToolbarItemClick={(args) => {
        onToolbarItemClick?.({
          ...args,
          cardId,
          card: { type: ActivityCardTypeEnum.DirectReportActivity, entity },
          cardPosition,
          directReport: true,
        });
      }}
      onClick={() => onClick?.(cardId)}
      url={url}
      connectedRight={
        <>
          <Button
            size="small"
            variation="secondaryLite"
            onClick={(ev) => {
              ev.stopPropagation();
              onViewFeedClick(ev);
            }}
          >
            {formatMessage(messages.viewFeed)}
          </Button>
          {entity.canPost && (
            <Button
              size="small"
              className="ml-3"
              variation="secondaryEmphasized"
              onClick={handleOnStartPostClick}
            >
              {formatMessage(messages.startPost)}
            </Button>
          )}
        </>
      }
      primaryToolbarItems={primaryToolbarItems}
      secondaryToolbarItems={secondaryToolbarItems}
      wrapperRef={cardWrapperRef}
      preview={preview}
    />
  );
}
